// Estimated dispatch date shown on the product page, using the same business
// rules as the order status lookup tool: framed prints = 7 working days,
// large standalone prints (20x16/24x16/30x20) = 5 working days, everything
// else = next working day. Weekends, UK bank holidays, and merchant-configured
// closure dates (Theme settings > Estimated dispatch) are skipped, and orders
// placed at/after 5pm UK time count from the next calendar day.
(function () {
  var FRAME_KEYWORDS = ['black frame', 'white frame', 'silver frame', 'classic frame'];
  var LARGE_SIZE_KEYWORDS = ['20 x 16', '24 x 16', '30 x 20', '23.4 x 16.5 (a2)', '33.1 x 23.4 (a1)', '36 x 24', '46.8 x 33.1 (a0)'];
  var ORDER_CUTOFF_HOUR = 17;

  // Merchant-configured closure dates (holidays/breaks), set via theme settings
  // and injected as window.themeDispatchClosureDates. Treated the same as bank
  // holidays: one entry per line, either "YYYY-MM-DD" or "YYYY-MM-DD to YYYY-MM-DD".
  function closureDatesFromSettings(raw) {
    var set = {};
    if (!raw) return set;
    raw.split(/\r?\n/).forEach(function (line) {
      line = line.trim();
      if (!line || line.charAt(0) === '#') return;

      var rangeMatch = line.match(/^(\d{4}-\d{2}-\d{2})\s+to\s+(\d{4}-\d{2}-\d{2})$/i);
      if (rangeMatch) {
        var current = new Date(rangeMatch[1] + 'T00:00:00Z');
        var end = new Date(rangeMatch[2] + 'T00:00:00Z');
        while (current <= end) {
          set[toDateKey(current)] = true;
          current.setUTCDate(current.getUTCDate() + 1);
        }
        return;
      }

      if (/^\d{4}-\d{2}-\d{2}$/.test(line)) set[line] = true;
    });
    return set;
  }

  var bankHolidaysPromise = fetch('https://www.gov.uk/bank-holidays.json')
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var events = (data['england-and-wales'] && data['england-and-wales'].events) || [];
      var set = {};
      events.forEach(function (e) { set[e.date] = true; });
      return set;
    })
    .catch(function () {
      return {};
    })
    .then(function (bankHolidays) {
      var closureDates = closureDatesFromSettings(window.themeDispatchClosureDates);
      for (var key in closureDates) {
        if (closureDates.hasOwnProperty(key)) bankHolidays[key] = true;
      }
      return bankHolidays;
    });

  // Accepts a lowercased string (e.g. variant options joined together) and
  // returns the working-day rule that applies, via simple substring matching.
  function workingDaysForText(text) {
    var i;
    for (i = 0; i < FRAME_KEYWORDS.length; i++) {
      if (text.indexOf(FRAME_KEYWORDS[i]) !== -1) return 7;
    }
    for (i = 0; i < LARGE_SIZE_KEYWORDS.length; i++) {
      if (text.indexOf(LARGE_SIZE_KEYWORDS[i]) !== -1) return 5;
    }
    return 1;
  }

  function ukDateParts(date) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(date);
    var get = function (type) {
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === type) return parts[i].value;
      }
    };
    return { year: get('year'), month: get('month'), day: get('day'), hour: parseInt(get('hour'), 10) };
  }

  function ukReceivedDate(date) {
    var p = ukDateParts(date);
    var anchor = new Date(p.year + '-' + p.month + '-' + p.day + 'T00:00:00Z');
    if (p.hour >= ORDER_CUTOFF_HOUR) {
      anchor.setUTCDate(anchor.getUTCDate() + 1);
    }
    return anchor;
  }

  function toDateKey(date) {
    return date.toISOString().slice(0, 10);
  }

  function isWorkingDay(date, bankHolidays) {
    var weekday = date.getUTCDay();
    if (weekday === 0 || weekday === 6) return false;
    return !bankHolidays[toDateKey(date)];
  }

  function addWorkingDays(date, days, bankHolidays) {
    var result = new Date(date);
    var added = 0;
    while (added < days) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (isWorkingDay(result, bankHolidays)) added += 1;
    }
    return result;
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
  }

  function renderEstimatedDispatch(el, workingDays, label) {
    bankHolidaysPromise.then(function (bankHolidays) {
      var orderDate = ukReceivedDate(new Date());
      var dispatchDate = addWorkingDays(orderDate, workingDays, bankHolidays);
      el.textContent = label + formatDate(dispatchDate);
    });
  }

  function updateEstimatedDispatch(options) {
    var cuTextDiv = document.getElementById('cu_text');
    if (!cuTextDiv || !options || !options.length) return;

    var text = options.join(' ').toLowerCase();
    renderEstimatedDispatch(cuTextDiv, workingDaysForText(text), 'Estimated Dispatch Date: ');
  }

  function updateCartEstimatedDispatch() {
    var el = document.getElementById('cart_estimated_dispatch');
    if (!el) return;

    var itemTexts = (el.getAttribute('data-cart-options') || '').split('||').filter(Boolean);
    if (itemTexts.length === 0) return;

    var maxWorkingDays = 1;
    itemTexts.forEach(function (text) {
      var days = workingDaysForText(text.toLowerCase());
      if (days > maxWorkingDays) maxWorkingDays = days;
    });

    renderEstimatedDispatch(el, maxWorkingDays, 'Estimated Dispatch Date: ');
  }

  // The cart drawer's contents are patched in by JS on add/remove rather than
  // a full Liquid re-render, so fetch the live cart instead of relying on a
  // server-rendered data attribute that would otherwise go stale.
  function updateCartDrawerEstimatedDispatch() {
    var el = document.getElementById('cart_drawer_estimated_dispatch');
    if (!el) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          el.textContent = '';
          return;
        }
        var maxWorkingDays = 1;
        cart.items.forEach(function (item) {
          var days = workingDaysForText((item.variant_title || '').toLowerCase());
          if (days > maxWorkingDays) maxWorkingDays = days;
        });
        renderEstimatedDispatch(el, maxWorkingDays, 'Estimated Dispatch Date: ');
      })
      .catch(function () {});
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (variant && variant.options) {
      updateEstimatedDispatch(variant.options);
    }
  });

  document.addEventListener('cart:updated', updateCartDrawerEstimatedDispatch);
  document.addEventListener('drawerOpen', updateCartDrawerEstimatedDispatch);

  document.addEventListener('DOMContentLoaded', function () {
    var cuTextDiv = document.getElementById('cu_text');
    if (cuTextDiv) {
      var options = (cuTextDiv.getAttribute('data-options') || '').split('|').filter(Boolean);
      updateEstimatedDispatch(options);
    }

    updateCartEstimatedDispatch();
    updateCartDrawerEstimatedDispatch();
  });
})();
